import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  groups: {
    dashboards: {
      name: "Painéis",
      icon: "ni ni-tv-2 text-blue",
      path: "/dashboards",
      permissions: ["any"],
    },
    crop: {
      name: "Safras",
      icon: "fa fa-leaf text-success",
      permissions: ["anosafra", "culture"],
    },
    creation: {
      name: "Cadastro",
      icon: "fas fa-table text-success",
      path: "/cadastro",
      permissions: ["any"],
    },
    avaliation: {
      name: "Avaliações",
      icon: "fas fa-solid fa-clipboard text-blue",
      path: "/cadastro",
      permissions: ["any"],
    },
    products: {
      name: "Produtos",
      icon: "fa fa-shopping-cart text-info",
      permissions: ["grupo", "gruposgv", "product", "preferredproduct"],
    },
    promoções: {
      name: "Promoções",
      icon: "fa fa-dollar-sign text-success",
      path: "/promocoes",
      permissions: ["any"],
    },
    campanha: {
      name: "Campanha",
      icon: "fas fa-hand-holding-usd text-default",
      path: "/campanhas",
      permissions: ["any"],
    },
    /*
        campanhas: {
          name: "Campanhas",
          icon: "fas fa-hand-holding-usd text-default",
          path: "/campanhas",
          permissions: ["any"],
        },
        */
    orders: {
      name: "Pedidos",
      icon: "fa fa-edit text-warning",
      path: "/orders",
      permissions: ["any"],
    },
    // clients: {
    //   name: "Clientes",
    //   icon: "fa fa-users text-default",
    //   permissions: ["any"],
    // },
    schedule: {
      name: "Agenda",
      icon: "fa fa-calendar-alt text-danger",
      permissions: ["any"],
    },
    // salesman: {
    //   name: "Vendedores",
    //   icon: "fa fa-user-tag text-default",
    //   permissions: ["any"],
    // },
    abccurve: {
      name: "Curva ABC",
      icon: "fa fa-chart-line",
      path: "/abccurve",
      permissions: ["any"],
    },
    // territorial: {
    //   name: "Área de Atuação",
    //   icon: "fa fa-map text-success",
    //   path: "/territorial",
    //   permissions: ["any"],
    // },
    // 'goal': {
    //   name: 'Objetivos',
    //   icon: 'fa fa-bullseye text-default',
    //   permissions: ['any'],
    // },
    reports: {
      name: "Relatórios",
      icon: "fa fa-file-alt text-blue",
      // path: '/dashboards',
      permissions: ["dashboard"],
    },
    admin: {
      name: "Administração",
      icon: "fa fa-cogs text-danger",
      path: "/admin/users",
      permissions: ["user", "role"],
    },
    PPR: {
      name: "PPR",
      icon: "fas fa-address-card text-info",
      path: "/admin/ppr",
      permissions: ["participation_ppr"],
      hideMobile: true,
    },
    commercial: {
      name: "Comercial",
      icon: "fa fa-dollar-sign text-success",
      path: "/commercial",
      permissions: ["any"],
    },
    support: {
      name: "Suporte",
      icon: "fas fa-headset text-red",
      path: "/support",
      permissions: ["any"],
    },
    CRI: {
      name: "Módulo de Crédito",
      icon: "fas fa-credit-card text-yellow",
      path: "/cri/main",
      permissions: ["participation_ppr"],
      hideMobile: true,
    },
  },
  groupsPPR: {
    PPR: {
      name: "PPR",
      icon: "fas fa-address-card text-blue",
      path: "/admin/ppr",
      permissions: ["participation_ppr"],
    },
    HF: {
      name: "Comercial HF",
      icon: "fas fa-apple-alt text-blue",
      path: "/admin/ppr/hf",
      permissions: ["participation_ppr"],
    },
    Cereal: {
      name: "Comercial Cereal",
      icon: "fas fa-seedling text-blue",
      path: "/admin/ppr/cereal",
      permissions: ["participation_ppr"],
    },
    PlanoMetas: {
      name: "Plano de Metas Bayer",
      icon: "fas fa-clipboard text-blue",
      path: "/admin/ppr/plano_de_metas",
      permissions: ["participation_ppr"],
    },
    AvaliacaoResumo: {
      name: "Avaliação Resumo",
      icon: "fas fa-chart-pie text-blue",
      path: "/admin/ppr/avaliacao",
      permissions: ["participation_ppr"],
    },
    AvaliacaoCOM: {
      name: "Avaliação COM",
      icon: "fas fa-user-check text-blue",
      path: "/admin/ppr/avaliacaocom",
      permissions: ["participation_ppr"],
    },
    AvaliacaoAGD: {
      name: "Avaliação AGD",
      icon: "fas fa-globe text-blue",
      path: "/admin/ppr/avaliacaoagd",
      permissions: ["participation_ppr"],
    },
    Vendas: {
      name: "Venda Direta",
      icon: "fas fa-receipt text-blue",
      path: "/admin/ppr/directSelling",
      permissions: ["participation_ppr"],
    },
    VendaDireta: {
      name: "Plano Venda Direta",
      icon: "fas fa-file-invoice-dollar  text-blue",
      path: "/admin/ppr/sale",
      permissions: ["participation_ppr"],
    },
    Configurações: {
      name: "Anos PPR",
      icon: "fas fa-cog text-blue",
      path: "/admin/ppr/configuracao",
      permissions: ["participation_ppr"],
    },
    Relatórios: {
      name: "Relatórios",
      icon: "fa fa-file-alt text-blue",
      path: "/admin/ppr/reports",
      permissions: ["participation_ppr"],
    },
    Metas: {
      name: "Metas",
      icon: "fas fa-comments-dollar text-blue",
      path: "/admin/ppr/metas",
      permissions: ["participation_ppr"],
    },
    SGV: {
      name: "SGV",
      icon: "fas fa-spa text-blue",
      path: "/",
      permissions: ["participation_ppr"],
    },
  },
  groupsCRI: {
    Cliente: {
      name: "Cliente",
      icon: "fas fa-user-friends text-blue",
      path: "/cri/main",
      permissions: ["any"],
    },
    Propostas: {
      name: "Propostas",
      icon: "fa fa-dollar-sign text-blue",
      path: "/cri/proposal",
      permissions: ["any"],
    },
    Relatórios: {
      name: "Relatórios",
      icon: "fa fa-copy text-blue",
      path: "/cri/reports",
      permissions: ["any"],
    },
    Aprovações: {
      name: "Aprovações",
      icon: "fa fa-cogs text-blue",
      path: "/cri/approvals",
      permissions: ["any"],
    },
    SGV: {
      name: "SGV",
      icon: "fas fa-spa text-blue",
      path: "/",
      permissions: ["any"],
    },
  },
  routes: [
    {
      path: "/",
      redirect: (to) => {
        return "/dashboards";
      },
    },
    {
      path: "/reset_password/:token",
      name: "Reset",
      meta: {
        layout: "authentication-layout",
        skipLogin: true,
        hideFromSidenav: true,
      },
      component: () => import("@/views/authentication/ResetPassword"),
    },
    {
      path: "/login/",
      name: "Login",
      meta: {
        layout: "authentication-layout",
        skipLogin: true,
        hideFromSidenav: true,
      },
      component: () => import("@/views/authentication/Login"),
    },
    {
      path: "/recuperacaoConta/",
      name: "Recuperação de Conta",
      meta: {
        layout: "authentication-layout",
        skipLogin: true,
        hideFromSidenav: true,
      },
      component: () => import("@/views/authentication/ForgetPassword"),
    },
    {
      path: "/anosafra",
      name: "Anos Safra",
      component: () => import("@/views/AnoSafra/ListAnoSafra"),
      meta: {
        layout: "dashboard-layout",
        group: "crop",
        permissions: ["anosafra"],
      },
    },
    {
      path: "/culturas",
      name: "Culturas",
      component: () => import("@/views/Cultures/Index.vue"),
      meta: {
        layout: "dashboard-layout",
        group: "crop",
        permissions: ["culture"],
      },
    },
    {
      path: "/admin/settings",
      name: "Configurações",
      component: () => import("@/views/Settings/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "admin",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/history",
      name: "Histórico de Ações",
      component: () => import("@/views/History/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "admin",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/users",
      name: "Usuarios",
      component: () => import("@/views/users/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "admin",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/dashboards",
      name: "Dashboards do Sistema",
      component: () => import("@/views/SystemAdmin/Dashboards/index.vue"),
      meta: {
        layout: "dashboard-layout",
        group: "admin",
        hideFromSidenav: true,
      },
      children: [
        {
          path: "/admin/dashboards/goals",
          name: "Paineis Administrativos de Metas",
          component: () => import("@/views/SystemAdmin/Dashboards/Goals"),
        },
        {
          path: "/admin/dashboards/service_info",
          name: "Painel de versões de serviços docker",
          component: () => import("@/views/SystemAdmin/Dashboards/DockerServiceInfo"),
          hideFromSidenav: true,
        },
      ],
    },
    {
      name: "Campanha",
      path: "/campanhas",
      component: () => import("@/views/NewCampaign/Campaign"),
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        visibleOnSearch: true,
        group: "campanha",
        permissions: ["any"],
      },
    },
    {
      path: "/ocupationArea",
      name: "Área de Atuação",
      component: () => import("@/views/Reports/OcupationArea"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        permissions: ["any"],
      },
    },
    {
      path: "/clients",
      name: "Carteira de Clientes",
      component: () => import("@/views/clients/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        permissions: ["any"],
      },
    },
    {
      path: "/register",
      name: "Ficha Cadastral PF",
      component: () => import("@/views/clients/RegisterClient"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        hideFromSidenav: true,
        permissions: ["client", "role"],
      },
    },
    {
      path: "/registerJuridica",
      name: "Ficha Cadastral PJ",
      component: () => import("@/views/clients/RegisterJuridical"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        hideFromSidenav: true,
        permissions: ["client", "role"],
      },
    },
    {
      path: "/regions",
      name: "Regiões",
      component: () => import("@/views/Regions/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/properties",
      name: "Propriedades",
      component: () => import("@/views/Properties/Index"),
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        group: "creation",
        permissions: ["client", "role"],
      },
    },
    {
      path: "/filiais",
      name: "Filiais",
      component: () => import("@/views/Branch/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        permissions: ["any"],
      },
    },
    {
      path: "/sectors",
      name: "Setores",
      component: () => import("@/views/Sectors/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        permissions: ["any"],
      },
    },
    {
      path: "/plano_de_metas",
      name: "Metas",
      component: () => import("@/views/Goals/Goals"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        permissions: ["any"],
      },
    },
    {
      path: "/metas_compra_fornecedor",
      name: "Metas de compra por fornecedor",
      component: () => import("@/views/SupplierPurchaseGoal/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        permissions: ["supplier_purchase_goal"],
      },
    },
    {
      path: "/salesmans",
      name: "Vendedores",
      component: () => import("@/views/Salesman/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "creation",
        permissions: ["any"],
      },
    },
    {
      path: "/avaliacoes/avalicao_360",
      name: "Avaliação 360",
      component: () => import("@/views/Avaliations/ListAvaliations"),
      meta: {
        layout: "dashboard-layout",
        avaliationType: "feedback360",
        group: "avaliation",
        permissions: ["any"],
      },
    },
    {
      path: "/avaliacoes/:avaliationId/respostas",
      name: "Respostas de Avaliações",
      component: () => import("@/views/Avaliations/AvaliationResponses"),
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        permissions: ["any"],
      },
    },
    {
      name: "Curva ABC",
      path: "/abccurve",
      component: () => import("@/views/CurveABC/index.vue"),
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        visibleOnSearch: true,
        group: "abccurve",
        permissions: ["any"],
      },
    },
    {
      path: "/visitas/agendar",
      name: "Agendar Visita",
      component: () => import("@/views/clients/AgendarVisita"),
      meta: {
        layout: "dashboard-layout",
        group: "schedule",
        permissions: ["any"],
      },
    },
    {
      path: "/visitas/tipos",
      name: "Tipos de Visitas",
      component: () => import("@/views/visits/visitType"),
      meta: {
        layout: "dashboard-layout",
        group: "schedule",
        permissions: ["any"],
      },
    },
    {
      path: "/visitas/relatorios",
      name: "Relatório de Visitas",
      component: () => import("@/views/visits/VisitReports"),
      meta: {
        layout: "dashboard-layout",
        group: "schedule",
        permissions: ["any"],
      },
    },
    {
      path: "/visitas/book",
      name: "Book de Visitas",
      component: () => import("@/views/visits/VisitBook"),
      meta: {
        layout: "dashboard-layout",
        group: "schedule",
        permissions: ["any"],
      },
    },
    {
      path: "*",
      name: "404*",
      component: require("@/views/error/404.vue").default, // load sync home
      meta: {
        skipLogin: true,
        hideFromSidenav: true,
      },
    },
    {
      path: "/products",
      name: "Pesquisar Produtos",
      meta: {
        layout: "dashboard-layout",
        group: "products",
        permissions: ["any"],
      },
      // component: DashboardLayout,
      component: () => import("@/views/Products/Index"),
    },
    {
      path: "/preferredproduct",
      name: "Produto Preferencial",
      meta: {
        layout: "dashboard-layout",
        group: "products",
        permissions: ["any"],
      },
      // component: DashboardLayout,
      component: () => import("@/views/Products/PreferredProduct"),
    },
    {
      path: "/segmentculture",
      name: "Segmento e Cultura",
      component: () => import("@/views/Products/ChannelCulture"),
      meta: {
        layout: "dashboard-layout",
        group: "products",
        permissions: ["grupo", "gruposgv"],
      },
    },
    {
      path: "/vinculargrupos",
      name: "Vincular Grupos",
      component: () => import("@/views/Goals/Vinculargrupos"),
      meta: {
        layout: "dashboard-layout",
        group: "products",
        permissions: ["grupo", "gruposgv"],
      },
    },

    // {
    //   path: '/relatorios/geral',
    //   name: 'Relatórios',
    //   meta: {
    //     layout: 'dashboard-layout',
    //     group: 'reports',
    //     permissions: ['any'], // TODO: change to report
    //   },
    //   component: () => import("@/views/Reports/Generic")
    // },
    // {
    //   path: "/relatorios/campanhas",
    //   name: "Campanhas",
    //   meta: {
    //     layout: "dashboard-layout",
    //     group: "reports",
    //     permissions: ["any"], // TODO: change to report
    //   },
    //   component: () => import("@/views/Reports/Campaigns.vue"),
    // },
    {
      path: "/relatorios/clientes",
      name: "Carteira de Clientes",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Clients"),
    },
    {
      path: "/relatorios/aquisicao_retencao_clientes",
      name: "Aquisição/retenção de Clientes",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/ClientRetentionAcquisition.vue"),
    },
    {
      path: "/relatorios/pedidos",
      name: "Pedidos",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Orders"),
    },
    {
      path: "/relatorios/vendedores",
      name: "Carteira Gerente Comercial e Vendedor",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Salesman"),
    },
    {
      path: "/relatorios/cultura_por_estado",
      name: "Cultura por Estado",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/CultureByStates"),
    },
    {
      path: "/relatorios/GoalsByBrands",
      name: "Distribuição de Metas",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/GoalsByBrands"),
    },
    {
      path: "/relatorios/KmPorLitro",
      name: "Frota",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/FuelUsage.vue"),
    },
    {
      path: "/relatorios/logs",
      name: "Logs",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Logs"),
    },
    {
      path: "/relatorios/analitico_meta",
      name: "Meta Analitica",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/AnalyticalGoal"),
    },
    {
      path: "/relatorios/analitico_cliente",
      name: "Meta Analitica Clientes",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/AnalyticalClient"),
    },
    {
      path: "/relatorios/meta_financeira",
      name: "Meta Financeira",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Goals"),
    },
    {
      path: "/relatorios/meta_por_cliente",
      name: "Meta por Cliente",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/GoalsByClients"),
    },
    {
      path: "/relatorios/agendamentos",
      name: "Agendamentos",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Schedules"),
    },
    {
      path: "/relatorios/potencial_cliente",
      name: "Potencial por Cliente",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/PotentialClients.vue"),
    },
    {
      path: "/relatorios/pendencias",
      name: "Pendencias",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Pendency"),
    },
    {
      path: "/relatorios/Preferredproducts",
      name: "Produtos Preferenciais",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Preferredproducts"),
    },
    {
      path: "/relatorios/volume_vendas",
      name: "Vendas",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/SalesVolume"),
    },
    {
      path: "/relatorios/estoque",
      name: "Estoque",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Inventory.vue"),
    },
    {
      path: "/relatorios/comercial",
      name: "Liberação Comercial",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["any"], // TODO: change to report
      },
      component: () => import("@/views/Reports/Commercial.vue"),
    },
    {
      path: "/relatorios/permissoes",
      name: "Permissões",
      meta: {
        layout: "dashboard-layout",
        group: "reports",
        permissions: ["permission", "role", "user"],
      },
      component: () => import("@/views/Reports/Permissions.vue"),
    },
    {
      path: "/dashboards",
      name: "Geral",
      meta: {
        layout: "dashboard-layout",
        group: "dashboards",
        permissions: ["any"],
      },
      // component: DashboardLayout,
      // component: () => import("@/layouts/DashboardLayout")
      component: () => import("@/views/Dashboards/General"),
    },
    {
      path: "/admin/dashboards/goals",
      name: "Painel Administrativo de Metas",
      component: () => import("@/views/SystemAdmin/Dashboards/Goals"),
      meta: {
        layout: "dashboard-layout",
        group: "dashboards",
        permissions: ["role", "admin"],
      }
    },

    {
      path: "/dashboards/:id",
      name: "Dashboard",
      meta: {
        layout: "dashboard-layout",
        group: "dashboards",
        permissions: ["dashboard"],
        hideFromSidenav: true,
      },
      component: () => import("@/views/Dashboards/Show"),
    },
    {
      path: "/campaigns",
      name: "Campanhas",
      component: () => import("@/views/Campaigns/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "promoções",
        permissions: ["any"],
      },
    },
    {
      path: "/discounts",
      name: "Descontos",
      component: () => import("@/views/Discounts/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "promoções",
        permissions: ["any"],
      },
    },
    {
      path: "/campaigns/:campaign_id",
      name: "Campanha",
      component: {
        template: "<router-view></router-view>",
      },
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        group: "promoções",
        permissions: ["any"],
      },
    },
    {
      path: "/campaigns/:campaign_id/products",
      name: "campaign_products",
      component: () => import("@/views/Campaigns/Products"),
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        group: "promoções",
        permissions: ["any"],
      },
    },
    {
      path: "/campaigns/:campaign_id/brand_discounts",
      name: "brand_limits",
      component: () => import("@/views/Campaigns/BrandDiscounts"),
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        group: "promoções",
        permissions: ["any"],
      },
    },
    {
      path: "/campaigns/:campaign_id/quantity_discounts",
      name: "quantity_discounts",
      component: () => import("@/views/Campaigns/QuantityDiscounts"),
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        group: "promoções",
        permissions: ["any"],
      },
    },
    {
      path: "/campaigns/:campaign_id/campaign_discounts",
      name: "campaign_discounts",
      component: () => import("@/views/Campaigns/Discounts"),
      meta: {
        layout: "dashboard-layout",
        hideFromSidenav: true,
        group: "promoções",
        permissions: ["any"],
      },
    },
    {
      path: "/purchase_orders",
      name: "Pedidos",
      component: () => import("@/views/PurchaseOrders/Index"),
      meta: {
        layout: "dashboard-layout",
        group: "orders",
        permissions: ["any"],
      },
    },
    // {
    //   path: "/manager_purchase_orders",
    //   name: "Pedidos para Aprovação",
    //   component: () => import("@/views/PurchaseOrders/ManagerIndex"),
    //   meta: {
    //     // hideFromSidenav: !localStorage.currentUser.is_manager,
    //     layout: "dashboard-layout",
    //     group: "orders",
    //     permissions: ["any"],
    //   },
    // },
    {
      path: "/commercial_releases",
      name: "Liberações comerciais Pendentes",
      component: () => import("@/views/PurchaseOrders/commercialReleases"),
      meta: {
        // hideFromSidenav: !localStorage.currentUser.is_manager,
        layout: "dashboard-layout",
        group: "orders",
        permissions: ["any"],
      },
    },

    {
      path: "/purchase_orders/:purchase_order_id/order_items",
      name: "order_items",
      component: () => import("@/views/PurchaseOrders/OrderItems"),
      meta: {
        hideFromSidenav: true,
        group: "orders",
        permissions: ["any"],
      },
    },
    {
      path: "/purchase_orders/:purchase_order_id/invoice",
      name: "invoice",
      component: () => import("@/views/PurchaseOrders/Invoice"),
      meta: {
        hideFromSidenav: true,
        group: "orders",
        permissions: ["any"],
      },
    },
    {
      path: "/admin/ppr",
      name: "PPR",
      component: () => import("@/views/PPR/index"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        visibleOnSearch: true,
        groupsPPR: "orders",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/hf",
      name: "PPR HF",
      component: () => import("@/views/PPR/PprHf"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "HF",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/cereal",
      name: "PPR Cereal",
      component: () => import("@/views/PPR/PprCereal"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "Cereal",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/plano_de_metas",
      name: "Plano de Metas Bayer",
      component: () => import("@/views/PPR/Goals"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "PlanoMetas",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/avaliacao/grupo",
      name: "Grupo",
      component: () => import("@/views/PPR/EvaluationResumeG"),
      meta: {
        layout: "ppr-layout",
        // hideFromSidenav: true,
        hideFromSidenavSGV: true,
        groupsPPR: "AvaliacaoResumo",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/avaliacao/pessoal",
      name: "Pessoal",
      component: () => import("@/views/PPR/EvaluationResumeP"),
      meta: {
        layout: "ppr-layout",
        // hideFromSidenav: true,
        hideFromSidenavSGV: true,
        groupsPPR: "AvaliacaoResumo",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/avaliacaocom/grupo",
      name: "Grupo",
      component: () => import("@/views/PPR/EvaluationComG"),
      meta: {
        layout: "ppr-layout",
        // hideFromSidenav: true,
        hideFromSidenavSGV: true,
        groupsPPR: "AvaliacaoCOM",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/avaliacaocom/pessoal",
      name: "Pessoal",
      component: () => import("@/views/PPR/EvaluationComP.vue"),
      meta: {
        layout: "ppr-layout",
        // hideFromSidenav: true,
        hideFromSidenavSGV: true,
        groupsPPR: "AvaliacaoCOM",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/avaliacaoagd/grupo",
      name: "Grupo",
      component: () => import("@/views/PPR/EvaluationAgdG"),
      meta: {
        layout: "ppr-layout",
        // hideFromSidenav: true,
        hideFromSidenavSGV: true,
        groupsPPR: "AvaliacaoAGD",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/avaliacaoagd/pessoal",
      name: "Pessoal",
      component: () => import("@/views/PPR/EvaluationAgdP"),
      meta: {
        layout: "ppr-layout",
        // hideFromSidenav: true,
        hideFromSidenavSGV: true,
        groupsPPR: "AvaliacaoAGD",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/sale",
      name: "Venda Direta",
      component: () => import("@/views/PPR/Sale"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "VendaDireta",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/sale",
      name: "Venda Direta",
      component: () => import("@/views/PPR/Sale"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "VendaDireta",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/DirectSelling",
      name: "Plano Venda Direta",
      component: () => import("@/views/PPR/DirectSelling"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "Vendas",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/reports",
      name: "Relatórios Avaliação",
      component: () => import("@/views/PPR/Reports"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "Relatórios",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/configuracao",
      name: "Configuração",
      component: () => import("@/views/PPR/PprConfig"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "Configuracao",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/metas",
      name: "Relatórios",
      component: () => import("@/views/PPR/MainGoals"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenav: true,
        groupsPPR: "Meta Principal",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/avaliacao",
      name: "Relatório de Avaliação",
      component: () => import("@/views/PPR/Reports.vue"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenavSGV: true,
        groupsPPR: "Relatórios",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/admin/ppr/meta_financeira",
      name: "Meta Finaceira",
      component: () => import("@/views/PPR/Reports/FinancialGoalReport.vue"),
      meta: {
        layout: "ppr-layout",
        hideFromSidenavSGV: true,
        groupsPPR: "Relatórios",
        permissions: ["user", "role"],
      },
    },
    /*
        {
          path: '/campaignSB',
          name: 'Campanha Safra Boa',
          component: () => import("@/views/NewCampaigns/campaignHarvest"),
          meta: {
            layout: 'dashboard-layout',
            group: 'campanhas',
            permissions: ['any'],
          },
        },
        {
          path: '/campaignMB',
          name: 'Campanha Milho Bom é Bayer',
          component: () => import("@/views/NewCampaigns/campaignCorn"),
          meta: {
            layout: 'dashboard-layout',
            group: 'campanhas',
            permissions: ['any'],
          },
        },
        */
    {
      name: "Condição Comercial",
      path: "/commercial/condicao",
      component: () => import("@/views/Commercial/Condition.vue"),
      meta: {
        layout: "dashboard-layout",
        //hideFromSidenav: true,
        group: "commercial",
        permissions: ["any"],
      },
    },
    {
      name: "Períodos Comerciais",
      path: "/commercial",
      component: () => import("@/views/Commercial/Index.vue"),
      meta: {
        layout: "dashboard-layout",
        //hideFromSidenav: true,
        group: "commercial",
        permissions: ["any"],
      },
    },
    {
      name: "Alterar senha",
      path: "/updatePassword",
      component: () => import("@/views/users/components/UpdatePassword"),
      meta: {
        layout: "dashboard-layout"
      },
    },
    {
      name: "Senha expirada",
      path: "/expired_password",
      component: () => import("@/views/users/components/UpdatePassword"),
      meta: {
        layout: "authentication-layout"
      },
    },
    {
      name: "Suporte",
      path: "/support",
      component: () => import("@/views/Support/index"),
      meta: {
        layout: "dashboard-layout",
        visibleOnSearch: true,
        group: "support"
      },
    },
    {
      path: "/cri/main",
      name: "Módulo de Crédito",
      component: () => import("@/views/CRI/Client"),
      meta: {
        layout: "cri-layout",
        hideFromSidenav: true,
        visibleOnSearch: true,
        groupsCRI: "Principal",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/cri/proposal",
      name: "Proposta",
      component: () => import("@/views/CRI/Proposal"),
      meta: {
        layout: "cri-layout",
        hideFromSidenav: true,
        groupsCRI: "Proposta",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/cri/reports",
      name: "Relatórios Cri",
      component: () => import("@/views/CRI/Reports"),
      meta: {
        layout: "cri-layout",
        hideFromSidenav: true,
        groupsCRI: "Relatórios Cri",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/cri/approvals",
      name: "Aprovações",
      component: () => import("@/views/CRI/Approvals"),
      meta: {
        layout: "cri-layout",
        hideFromSidenav: true,
        groupsCRI: "Aprovações",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/cri/reports/aprovals",
      name: "Propostas",
      component: () => import("@/views/CRI/reports/proposals.vue"),
      meta: {
        layout: "cri-layout",
        hideFromSidenavSGV: true,
        groupsCRI: "Relatórios",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/cri/reports/clients",
      name: "Clientes CRI",
      component: () => import("@/views/CRI/reports/clients.vue"),
      meta: {
        layout: "cri-layout",
        hideFromSidenavSGV: true,
        groupsCRI: "Relatórios",
        permissions: ["user", "role"],
      },
    },
    {
      path: "/cri/reports/ticket_medio",
      name: "Ticket Médio",
      component: () => import("@/views/CRI/reports/AverageTicket.vue"),
      meta: {
        layout: "cri-layout",
        hideFromSidenavSGV: true,
        groupsCRI: "Relatórios",
        permissions: ["user", "role"],
      },
    },
  ],
});

// Global before guard to redirect user to the login page when authentication is needed
router.beforeResolve((to, _from, next) => {
  if (to.matched.some((record) => record.meta.skipLogin)) {
    next();
  } else if (router.app.$currentUser && router.app.$currentUser() && router.app.$currentUser().token) {
    next();
  } else {
    next({
      name: "Login",
    });
  }
});

// // Updating page title
router.afterEach((to, _from) => {
  if (to.name) document.title = to.name + " - SGV";
  else document.title = "SGV";
});

export default router;
